function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { generatePropagationContext, isPlainObject, dateTimestampInSeconds, uuid4, logger } from '@sentry/utils';
import { updateSession } from './session.js';
import { _setSpanForScope, _getSpanForScope } from './utils/spanOnScope.js';
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */

var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */

var ScopeClass = /*#__PURE__*/function () {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called during event processing. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */

  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */

  /** Session */

  /** Request Mode Session Status */

  /** The client on this scope */

  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  function ScopeClass() {
    _classCallCheck(this, ScopeClass);

    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }
  /**
   * @inheritDoc
   */


  _createClass(ScopeClass, [{
    key: "clone",
    value: function clone() {
      var newScope = new ScopeClass();
      newScope._breadcrumbs = _toConsumableArray(this._breadcrumbs);
      newScope._tags = _objectSpread({}, this._tags);
      newScope._extra = _objectSpread({}, this._extra);
      newScope._contexts = _objectSpread({}, this._contexts);
      newScope._user = this._user;
      newScope._level = this._level;
      newScope._session = this._session;
      newScope._transactionName = this._transactionName;
      newScope._fingerprint = this._fingerprint;
      newScope._eventProcessors = _toConsumableArray(this._eventProcessors);
      newScope._requestSession = this._requestSession;
      newScope._attachments = _toConsumableArray(this._attachments);
      newScope._sdkProcessingMetadata = _objectSpread({}, this._sdkProcessingMetadata);
      newScope._propagationContext = _objectSpread({}, this._propagationContext);
      newScope._client = this._client;
      newScope._lastEventId = this._lastEventId;

      _setSpanForScope(newScope, _getSpanForScope(this));

      return newScope;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setClient",
    value: function setClient(client) {
      this._client = client;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setLastEventId",
    value: function setLastEventId(lastEventId) {
      this._lastEventId = lastEventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getClient",
    value: function getClient() {
      return this._client;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "lastEventId",
    value: function lastEventId() {
      return this._lastEventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addScopeListener",
    value: function addScopeListener(callback) {
      this._scopeListeners.push(callback);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addEventProcessor",
    value: function addEventProcessor(callback) {
      this._eventProcessors.push(callback);

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setUser",
    value: function setUser(user) {
      // If null is passed we want to unset everything, but still define keys,
      // so that later down in the pipeline any existing values are cleared.
      this._user = user || {
        email: undefined,
        id: undefined,
        ip_address: undefined,
        username: undefined
      };

      if (this._session) {
        updateSession(this._session, {
          user: user
        });
      }

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getUser",
    value: function getUser() {
      return this._user;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getRequestSession",
    value: function getRequestSession() {
      return this._requestSession;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setRequestSession",
    value: function setRequestSession(requestSession) {
      this._requestSession = requestSession;
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTags",
    value: function setTags(tags) {
      this._tags = _objectSpread(_objectSpread({}, this._tags), tags);

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTag",
    value: function setTag(key, value) {
      this._tags = _objectSpread(_objectSpread({}, this._tags), {}, _defineProperty({}, key, value));

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setExtras",
    value: function setExtras(extras) {
      this._extra = _objectSpread(_objectSpread({}, this._extra), extras);

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setExtra",
    value: function setExtra(key, extra) {
      this._extra = _objectSpread(_objectSpread({}, this._extra), {}, _defineProperty({}, key, extra));

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setFingerprint",
    value: function setFingerprint(fingerprint) {
      this._fingerprint = fingerprint;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setLevel",
    value: function setLevel(level) {
      this._level = level;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTransactionName",
    value: function setTransactionName(name) {
      this._transactionName = name;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setContext",
    value: function setContext(key, context) {
      if (context === null) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
      } else {
        this._contexts[key] = context;
      }

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setSession",
    value: function setSession(session) {
      if (!session) {
        delete this._session;
      } else {
        this._session = session;
      }

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getSession",
    value: function getSession() {
      return this._session;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "update",
    value: function update(captureContext) {
      if (!captureContext) {
        return this;
      }

      var scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;

      var _ref = scopeToMerge instanceof Scope ? [scopeToMerge.getScopeData(), scopeToMerge.getRequestSession()] : isPlainObject(scopeToMerge) ? [captureContext, captureContext.requestSession] : [],
          _ref2 = _slicedToArray(_ref, 2),
          scopeInstance = _ref2[0],
          requestSession = _ref2[1];

      var _ref3 = scopeInstance || {},
          tags = _ref3.tags,
          extra = _ref3.extra,
          user = _ref3.user,
          contexts = _ref3.contexts,
          level = _ref3.level,
          _ref3$fingerprint = _ref3.fingerprint,
          fingerprint = _ref3$fingerprint === void 0 ? [] : _ref3$fingerprint,
          propagationContext = _ref3.propagationContext;

      this._tags = _objectSpread(_objectSpread({}, this._tags), tags);
      this._extra = _objectSpread(_objectSpread({}, this._extra), extra);
      this._contexts = _objectSpread(_objectSpread({}, this._contexts), contexts);

      if (user && Object.keys(user).length) {
        this._user = user;
      }

      if (level) {
        this._level = level;
      }

      if (fingerprint.length) {
        this._fingerprint = fingerprint;
      }

      if (propagationContext) {
        this._propagationContext = propagationContext;
      }

      if (requestSession) {
        this._requestSession = requestSession;
      }

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "clear",
    value: function clear() {
      // client is not cleared here on purpose!
      this._breadcrumbs = [];
      this._tags = {};
      this._extra = {};
      this._user = {};
      this._contexts = {};
      this._level = undefined;
      this._transactionName = undefined;
      this._fingerprint = undefined;
      this._requestSession = undefined;
      this._session = undefined;

      _setSpanForScope(this, undefined);

      this._attachments = [];
      this._propagationContext = generatePropagationContext();

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addBreadcrumb",
    value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
      var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS; // No data has been changed, so don't notify scope listeners

      if (maxCrumbs <= 0) {
        return this;
      }

      var mergedBreadcrumb = _objectSpread({
        timestamp: dateTimestampInSeconds()
      }, breadcrumb);

      var breadcrumbs = this._breadcrumbs;
      breadcrumbs.push(mergedBreadcrumb);
      this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getLastBreadcrumb",
    value: function getLastBreadcrumb() {
      return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "clearBreadcrumbs",
    value: function clearBreadcrumbs() {
      this._breadcrumbs = [];

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addAttachment",
    value: function addAttachment(attachment) {
      this._attachments.push(attachment);

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "clearAttachments",
    value: function clearAttachments() {
      this._attachments = [];
      return this;
    }
    /** @inheritDoc */

  }, {
    key: "getScopeData",
    value: function getScopeData() {
      return {
        breadcrumbs: this._breadcrumbs,
        attachments: this._attachments,
        contexts: this._contexts,
        tags: this._tags,
        extra: this._extra,
        user: this._user,
        level: this._level,
        fingerprint: this._fingerprint || [],
        eventProcessors: this._eventProcessors,
        propagationContext: this._propagationContext,
        sdkProcessingMetadata: this._sdkProcessingMetadata,
        transactionName: this._transactionName,
        span: _getSpanForScope(this)
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setSDKProcessingMetadata",
    value: function setSDKProcessingMetadata(newData) {
      this._sdkProcessingMetadata = _objectSpread(_objectSpread({}, this._sdkProcessingMetadata), newData);
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setPropagationContext",
    value: function setPropagationContext(context) {
      this._propagationContext = context;
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getPropagationContext",
    value: function getPropagationContext() {
      return this._propagationContext;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureException",
    value: function captureException(exception, hint) {
      var eventId = hint && hint.event_id ? hint.event_id : uuid4();

      if (!this._client) {
        logger.warn('No client configured on scope - will not capture exception!');
        return eventId;
      }

      var syntheticException = new Error('Sentry syntheticException');

      this._client.captureException(exception, _objectSpread(_objectSpread({
        originalException: exception,
        syntheticException: syntheticException
      }, hint), {}, {
        event_id: eventId
      }), this);

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureMessage",
    value: function captureMessage(message, level, hint) {
      var eventId = hint && hint.event_id ? hint.event_id : uuid4();

      if (!this._client) {
        logger.warn('No client configured on scope - will not capture message!');
        return eventId;
      }

      var syntheticException = new Error(message);

      this._client.captureMessage(message, level, _objectSpread(_objectSpread({
        originalException: message,
        syntheticException: syntheticException
      }, hint), {}, {
        event_id: eventId
      }), this);

      return eventId;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "captureEvent",
    value: function captureEvent(event, hint) {
      var eventId = hint && hint.event_id ? hint.event_id : uuid4();

      if (!this._client) {
        logger.warn('No client configured on scope - will not capture event!');
        return eventId;
      }

      this._client.captureEvent(event, _objectSpread(_objectSpread({}, hint), {}, {
        event_id: eventId
      }), this);

      return eventId;
    }
    /**
     * This will be called on every set call.
     */

  }, {
    key: "_notifyScopeListeners",
    value: function _notifyScopeListeners() {
      var _this = this;

      // We need this check for this._notifyingListeners to be able to work on scope during updates
      // If this check is not here we'll produce endless recursion when something is done with the scope
      // during the callback.
      if (!this._notifyingListeners) {
        this._notifyingListeners = true;

        this._scopeListeners.forEach(function (callback) {
          callback(_this);
        });

        this._notifyingListeners = false;
      }
    }
  }]);

  return ScopeClass;
}(); // NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)

/**
 * Holds additional event information.
 */


var Scope = ScopeClass;
/**
 * Holds additional event information.
 */

export { Scope };